import { render } from "./QAtaskDetails.vue?vue&type=template&id=2484b364&scoped=true"
import script from "./QAtaskDetails.vue?vue&type=script&lang=js"
export * from "./QAtaskDetails.vue?vue&type=script&lang=js"

import "./QAtaskDetails.vue?vue&type=style&index=0&id=2484b364&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2484b364"]])

export default __exports__